import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: '400' }}>AI Implementation</h3>
            <p style={{ fontFamily: "'Inter', sans-serif" }}>Transforming enterprises through intelligent automation and secure AI integration.</p>
          </div>
          <div className="footer-section">
            <h3 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: '400' }}>Solutions</h3>
            <ul className="footer-links" style={{ fontFamily: "'Inter', sans-serif" }}>
              <li><Link to="/features">AI Assistant Development</Link></li>
              <li><Link to="/features">Data Integration</Link></li>
              <li><Link to="/features">Enterprise Security</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: '400' }}>Company</h3>
            <ul className="footer-links" style={{ fontFamily: "'Inter', sans-serif" }}>
              <li><Link to="/benefits">Benefits</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p style={{ fontFamily: "'Inter', sans-serif" }}>&copy; 2025 AI Implementation Services. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
